import { useMediaQuery, useTheme } from '@ltvco/refresh-lib/theme';
import { EmojiObjectsOutlined } from '@mui/icons-material';
import { type ReactElement } from 'react';

import { LEGAL_INTELLIGENCE_ROUTES } from '../CourtCases/constants';
import {
  LegalResearchTab,
  LegalResearchTabsNavigation,
} from '../CourtCases/v2/shared/LegalResearchTabs';
import { LegalSearchBreadcrumbs } from '../CourtCases/v2/shared/LegalSearchBreadcrumbs';
import { PatentSearch } from '../PatentSearch/PatentSearch';

import { IPHubTitle, IPShell } from './components';

const TAB_ICONS: Partial<Record<string, ReactElement>> = {
  'Patent Search': <EmojiObjectsOutlined fontSize="large" />,
};

const DISABLED_TABS = new Set(['Copyright Search']);

const TABS = [
  { label: 'Copyright Search', content: <></> },
  { label: 'Patent Search', content: <PatentSearch /> },
];

const BREADCRUMB_SEGMENTS = [
  { label: 'Legal Intelligence', to: LEGAL_INTELLIGENCE_ROUTES.BASE },
  { label: 'Intellectual Property' },
];

export const IntellectualPropertyPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <IPShell>
      <LegalSearchBreadcrumbs segments={BREADCRUMB_SEGMENTS} />
      <IPHubTitle component="h1" variant="h1">
        Intellectual Property
      </IPHubTitle>
      <LegalResearchTabsNavigation
        externalActiveTab={1}
        onTabChanged={() => {}}
        tab={(props) => (
          <LegalResearchTab
            {...props}
            icon={TAB_ICONS[props.label]}
            iconPosition={isMobile ? 'top' : 'start'}
            disabled={DISABLED_TABS.has(props.label)}
          />
        )}
        tabs={TABS}
      />
    </IPShell>
  );
};
